import { render } from "./EditConferenceModal.vue?vue&type=template&id=49b479b5"
import script from "./EditConferenceModal.vue?vue&type=script&lang=js"
export * from "./EditConferenceModal.vue?vue&type=script&lang=js"
script.render = render

export default script